import { apiClient } from "shared/utils";

export const postBrowseAbandonmentAiTemplateContentDisable = async (shopId: number) => {
  const { data } = await apiClient.post<void>(
    `/${shopId}/triggers/browse-abandonment/ai-template-content/disable`
  );

  return data;
};
